import React from 'react';
import {
  Box,
  Text,
  Flex,
  Circle,
  VStack,
  HStack,
  Heading,
  useColorModeValue,
} from '@chakra-ui/react';
import { ProcessStepProps } from '../types';

const ProcessStepPresentation: React.FC<ProcessStepProps> = ({ 
  title, 
  description, 
  icon, 
  stepNumber, 
  isLastStep = false 
}) => {
  const circleBg = useColorModeValue('brand.primary.base', 'brand.primary.base');
  const connectorBg = useColorModeValue('gray.200', 'gray.600');
  const boxBg = useColorModeValue('white', 'gray.700');
  const boxShadow = useColorModeValue('md', 'dark-lg');

  return (
    <Flex direction={{ base: 'column', md: 'row' }} align="center">
      <VStack spacing={4} align="center">
        <Circle
          size="60px"
          bg={circleBg}
          color="white"
          fontWeight="bold"
          fontSize="xl"
          position="relative"
          zIndex={1}
        >
          {icon}
        </Circle>
        
        {!isLastStep && (
          <Box
            height={{ base: '40px', md: '80px' }}
            width={{ base: '2px', md: '2px' }}
            bg={connectorBg}
          />
        )}
      </VStack>
      
      <Box
        ml={{ base: 0, md: 6 }}
        mt={{ base: 4, md: 0 }}
        p={6}
        bg={boxBg}
        borderRadius="lg"
        boxShadow={boxShadow}
        flex={1}
      >
        <HStack mb={2}>
          <Text 
            fontSize="sm" 
            fontWeight="bold" 
            color="brand.primary.base"
          >
            STEP {stepNumber}
          </Text>
        </HStack>
        <Heading as="h3" size="md" mb={2}>
          {title}
        </Heading>
        <Text color="gray.600">
          {description}
        </Text>
      </Box>
    </Flex>
  );
};

export default ProcessStepPresentation;